import { useQuery } from '@apollo/client';
import { CKSelectableItem } from 'clearkit';
import { useState } from 'react';

import query from './query-filters.graphql';

type FilterType = 'role' | 'seniority';
type SelectedFilter = string;
export type FilterValue = CKSelectableItem;
export type FilterSelectItem = CKSelectableItem;
type FilterSelectItems = CKSelectableItem[];

export function useProspectFilters() {
  const [role, setRole] = useState<SelectedFilter>('');
  const [seniority, setSeniority] = useState<SelectedFilter>('');
  const { data: filterData, loading } = useQuery(query);

  const update = (filter: FilterType, newValue: SelectedFilter) => {
    if (filter === 'role') {
      setRole(newValue);
    } else if (filter === 'seniority') {
      setSeniority(newValue);
    }
  };

  const prospectFilters = filterData?.prospectFilters;
  const roleItems = getRoleItems(prospectFilters?.role);
  const seniorityItems = getSeniorityItems(prospectFilters?.seniority);

  return { role, seniority, update, loading, roleItems, seniorityItems };
}

const FILTER_DIVIDER = {
  label: '',
  value: '',
  isDivider: true,
};

const ALL_ROLES_FILTER = {
  label: 'Any role',
  value: '',
};
function getRoleItems(items?: FilterValue[]): FilterSelectItems {
  if (!items) {
    return [];
  }

  return [ALL_ROLES_FILTER, FILTER_DIVIDER, ...items];
}

const ALL_SENIORITIES_FILTER = {
  label: 'Any seniority',
  value: '',
};
function getSeniorityItems(items?: FilterValue[]): FilterSelectItems {
  if (!items) {
    return [];
  }

  return [ALL_SENIORITIES_FILTER, FILTER_DIVIDER, ...items];
}
